const variables = {
  colors: {
    primary: '#00B0EF',
    secondary: '#0996D5',
    third: '#201E1F',
    white: '#fff',
    black: '#000',
  },

  fontFamilyJura: "'Jura', sans-serif",
  fontFamilyRoboto: "'Roboto', sans-serif",

  base: {
    margin: 10,
    padding: 15,
    radius: 4,
    defaultShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  },
};

export default variables;
